export default __webpack_public_path__ + "static/media/OfflineCOnsultationIcon.373cb02e.svg";